/*---

  General scripts for Unytii PRO

  Louis-Charles Blais [info@22agencecreative.ca]

---*/

// Liquid ajax cart config
liquidAjaxCart.conf("quantityTagAllowZero", true);


// Header height calc
let header = document.querySelector('header');
let body = document.querySelector('body')
let headerHeight = 0;
function calculateHeaderHeight() {
  headerHeight = header.getBoundingClientRect().bottom;
  body.style = "--header_bottom_distance: " + headerHeight + "px";
}
document.addEventListener("scroll", (event) => {
  calculateHeaderHeight();
});
addEventListener("resize", (event) => {
  calculateHeaderHeight();
});
document.addEventListener('DOMContentLoaded', function() {
  calculateHeaderHeight();
}, false);


// Megamenu tab switching
function megaMenuDisplayChild(childTarget) {
  let parentIndex = childTarget.split('-')[0];
  let childIndex = childTarget.split('-')[1];
  // hide all containers and display the good one
  let childs = document.querySelectorAll('#megamenu-' + parentIndex + ' .lower-child-group');
  for (let i = 0; i < childs.length; i++) {
    childs[i].classList.remove('active');
  }
  document.querySelector('#megamenu-child-' + parentIndex + '-' + childIndex).classList.add('active');
  // remove the active class on all labels and display the good one
  let childsLabels = document.querySelectorAll('#megamenu-' + parentIndex + ' .upper-child');
  for (let i = 0; i < childsLabels.length; i++) {
    childsLabels[i].classList.remove('active');
  }
  document.querySelector('#megamenu-child-label-' + parentIndex + '-' + childIndex).classList.add('active');
}


// Password input visibility 
function togglePasswordVisibility() {
  let input = event.target.parentNode.querySelector('input');
  let icon = event.target;
  if (input.type == 'password') {
    input.type = 'text';
    icon.classList.add('iconoir-eye-solid');
  } else {
    input.type = 'password';
    icon.classList.remove('iconoir-eye-solid');
  }
}



// auto slide
let autoSlideElements = document.querySelectorAll('.auto-slide');

function scrollElements() {
  for (let i = 0; i < autoSlideElements.length; i++) {
    if (autoSlideElements[i].matches(':hover') == false) { 
      if (autoSlideElements[i].scrollLeft < (autoSlideElements[i].scrollWidth - autoSlideElements[i].offsetWidth)) {
        autoSlideElements[i].scroll({
          left: autoSlideElements[i].scrollLeft + 1,
          behavior: "instant",
        });
      } else {
        autoSlideElements[i].scroll({
          left: 0,
          behavior: "instant",
        });
      }
    }
  }
}
setInterval(scrollElements, 16);















